import script from "./UnitResult.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitResult.vue?vue&type=script&setup=true&lang=js"

import "./UnitResult.vue?vue&type=style&index=0&id=9331fbf8&lang=css"

const __exports__ = script;

export default __exports__